import React, { useState, useEffect } from 'react';
import { generateFormLink, getFormMasterList } from '../services/api';
import '../css/GenerateLink.css';

function GenerateLink() {
  const [generatedLink, setGeneratedLink] = useState('');
  const [error, setError] = useState('');
  const [agentId, setAgentId] = useState(null);
  const [forms, setForms] = useState([]);
  const [selectedFormId, setSelectedFormId] = useState('');

  useEffect(() => {
    const storedAgentId = localStorage.getItem('agentId');
    if (storedAgentId) {
      setAgentId(parseInt(storedAgentId, 10));
      console.log("Agent ID in localStorage.", storedAgentId);

    } else {
      setError("Agent ID not found in local storage. Please log in.");
    }

    const fetchFormList = async () => {
      try {
        const response = await getFormMasterList();
        setForms(response.data);
      } catch (error) {
        setError("Failed to fetch forms.");
      }
    };

    fetchFormList();
  }, []);

  const handleGenerateLink = async () => {
    setError('');
    setGeneratedLink('');

    if (!agentId || !selectedFormId) {
      setError('Agent ID or Form not selected.');
      return;
    }

    try {
      console.log("selectedFormId.", selectedFormId);
      const response = await generateFormLink(agentId, selectedFormId);
      setGeneratedLink(response.data);
    } catch (err) {
      setError('Failed to generate link. Please try again.');
    }
  };

  return (
    <div className="generate-link-container">
      <div className="generate-link-form">
        <h2><p style={{ color: 'rgb(112, 16, 99)' }}>Generate Form Link</p></h2>
        {error && <p className="error-message">{error}</p>}

        <div className="generate-link-group">
        <label style={{ color: 'rgb(112, 16, 99)' }}>Select Form:</label>          <select
            value={selectedFormId}
            onChange={(e) => setSelectedFormId(e.target.value)}
          >
            <option value="">-- Select Form --</option>
            {forms.map((form) => (
              <option key={form.id} value={form.id}>
                {form.formName}
              </option>
            ))}
          </select>
        </div>

        <div className="generate-link-group">
          <button onClick={handleGenerateLink}>Generate Link</button>
        </div>

        {generatedLink && (
          <div className="generate-link-group">
            <h3>Generated Link:</h3>
            <textarea
              readOnly
              value={generatedLink}
              rows={4}
              cols={50}
              onClick={(e) => e.target.select()}
            />
            <p>
              <a href={generatedLink} target="_blank" rel="noopener noreferrer">
                {generatedLink}
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default GenerateLink;
